import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { AuthContext } from "../AuthContext";

export interface VendasDashboardVendedoraType {
    vendedorId: number;
    vendedorNome: string;
    quantidadeVendas: number;
    totalVendido: number;
    totalComissaoEstimado: number;
}

export interface VendasDashboardUltimaVendaType {
    vendaId: number;
    data: string | null;
    clienteNome: string;
    produtoNome: string;
    vendedoraNome: string;
    valor: number;
}

export interface VendasDashboardMetaResumoType {
    metaId: number;
    vendedorId: number;
    vendedorNome: string;
    periodoInicio: string;
    periodoFim: string;
    metaValor: number;
    valorVendido: number;
    percentualAtingido: number;
    saldoMeta: number;
    ativa: boolean;
}

export interface VendasDashboardResumoType {
    totalVendas: number;
    totalClientes: number;
    totalValorVendido: number;
    totalComissaoEstimado: number;
    ticketMedio: number;
    vendasDoPeriodo: number;
    vendedoras: VendasDashboardVendedoraType[];
    ultimasVendas: VendasDashboardUltimaVendaType[];
    metas: VendasDashboardMetaResumoType[];
}

export interface VendasDashboardFilterType {
    empresaId: number;
    dataInicial?: string | null;
    dataFinal?: string | null;
    vendedorId?: number | null;
}

export default function useVendasDashboard() {
    const showToast = useToast();
    const { handleLogout } = useContext(AuthContext);
    const [resumo, setResumo] = useState<VendasDashboardResumoType | null>(null);
    const [loading, setLoading] = useState(false);

    async function fetchResumo(filter: VendasDashboardFilterType): Promise<void> {
        setLoading(true);
        try {
            const { data } = await api.get<VendasDashboardResumoType>("/VendasDashboard/resumo", {
                params: filter,
            });
            setResumo(data);
        } catch (error: any) {
            if (error?.response?.status === 401) {
                handleLogout();
                showToast("error", "Sessão expirada. Faça login novamente.");
            } else {
                showToast("error", "Erro ao carregar dashboard de vendas.");
            }
        } finally {
            setLoading(false);
        }
    }

    return { resumo, loading, fetchResumo };
}
